import * as _ from "lodash"

import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset, ITree, IProfileFilter, ISearchSort
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {ColumnNodeProvider} from "../PA.UIM.Core/SearchTreeUtils";

import {WB_WorkflowStatusRow} from "../PA.Core/PAdbSchemaRows";
import {ASync} from "../PA.Core/Basic/ASync";


const vWB_Workflow_Status_Fields: {[id:string]: ISearchProviderField } = {
    WB_STATUS_ID:             {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Workflow Status WB Id',  columnResourceName: 'colWorkflowStatusWBId',      alignment: HorizAlignment.Center}, domainOptions: { }},
    STATUS_ID:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Workflow Status Id',     columnResourceName: 'colWorkflowStatusId',        alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50}},
    STATUS_NAME:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Workflow Status Name',   columnResourceName: 'colWorkflowStatusName',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}},
    STATUS_TYPE:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Type',           columnResourceName: 'colType',         alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50}},
    WB_WORKFLOW_ID:        {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Workflow ID',        columnResourceName: 'colWorkflowID',       alignment: HorizAlignment.Center}, domainOptions: { maxLength: 5}},
    APPROVED_IND:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Approved Ind',        columnResourceName: 'colApprovedInd',       alignment: HorizAlignment.Center}, domainOptions: { maxLength: 5}},
}

const vWB_Workflow_Status_KeyFields =
    {id:    'WB_STATUS_ID',
        id_ui: 'STATUS_ID',
        name:  'STATUS_NAME'}


class WorkflowStatusSearchByListSearchProvider
    implements  ISearchProvider {

    arrWB_WorkflowStatusRows:WB_WorkflowStatusRow[] = []

    constructor(WB_WorkflowStatusRows: WB_WorkflowStatusRow[]){
        this.arrWB_WorkflowStatusRows = WB_WorkflowStatusRows
    }

    get keyFields() { return vWB_Workflow_Status_KeyFields }

    get searchProviderFields(){
        return vWB_Workflow_Status_Fields
    }

    search(requestSpec: ISearchRequestSubset): Promise<any[]> {
        return ASync.resolve(_.map(this.arrWB_WorkflowStatusRows, (aWB_WorkflowStatusRow: WB_WorkflowStatusRow) => {
            return aWB_WorkflowStatusRow.toJSON()
        }))
    }

}


class WorkflowStatusSearchByListSearchProfile
    implements  ISearchProfile {

    aSearchProvider: ISearchProvider = undefined

    profileId = "default"
    profileName = "AutoSearch Only"
    renderOptions = { ui5ResourceId: "WorkflowStatusSearchByListProfile" }

    profileFilter: IProfileFilter[] = []

    profileDisplayFields = [
        'STATUS_NAME','STATUS_ID', 'STATUS_TYPE'
    ]

    profileTreeIdDefault = "default"
    profileTrees: ITree[] = [
        {treeId: "default",
            treeName: "By Hierarchy",
            nodeProviders: [ new ColumnNodeProvider(['TREE_PATH'], {defaultValues: "No Parent Status Set"})],
            renderOptions: {}}
    ]

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault = ""    //string;
    profileSorts: ISearchSort[] = [] //ISearchSort[];


    constructor(WB_WorkflowStatusRows: WB_WorkflowStatusRow[]){
        this.aSearchProvider = new WorkflowStatusSearchByListSearchProvider(WB_WorkflowStatusRows)
    }

    get profileSearchProvider(){ return this.aSearchProvider }

}


export class WorkflowStatusSearchByList
    implements  ISearch {

    constructor(WB_WorkflowStatusRows: WB_WorkflowStatusRow[], options?: any){
        this.searchProfiles = [ new WorkflowStatusSearchByListSearchProfile(WB_WorkflowStatusRows) ]
    }

    searchName = "Select Workflow Status(s)"
    renderOptions = { ui5ResourceId: "WorkflowStatusSearchByList"}
    searchProfileIdDefault = "default"
    searchProfiles: ISearchProfile[] = []
    autoSearch = true

}
